import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import {
  useAddMrTransactionMutation,
  useAddTransactionMutation,
  useGetMrTransactionQuery,
  useGetPyTransactionQuery,
} from "../../features/api/transactionApi";
import CommonSearch2 from "../../components/CommonSearch2";
import { getuser } from "../../components/CommonDateFormat";
import { bankList } from "../../data";
import { useGetInvoicesQuery } from "../../features/api/orderinvoiceApi";
import { useGetSuppliersQuery } from "../../features/api/supplierApi";
import { useGetPurchasesQuery } from "../../features/api/purchaseApi";

const CashPayment = () => {
  const user = getuser();

  const suppliers = useGetSuppliersQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.supplier;

  const purchases = useGetPurchasesQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data;

  const [trDate, setTrDate] = useState("");
  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setTrDate(currentDate);
  }, []);

  const allPy = useGetPyTransactionQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data;

  let maxPy = 0;
  allPy?.map((data) => {
    const mrNo = data?.jv_no;
    const invSeperate = mrNo?.split("-");
    const generateAgain = invSeperate?.[2];
    if (!isNaN(generateAgain) && +generateAgain > +maxPy) {
      maxPy = generateAgain;
    }
  });
  const currentYear = new Date(trDate).getFullYear();
  const genPy = `PY-${currentYear}-${+maxPy + 1}`;
  const [prevMrNo, setPrevMrNo] = useState(null);
  const passState = prevMrNo
    ? `PY-${currentYear}-${prevMrNo}`
    : `PY-${currentYear}-${+maxPy}`;

  // const [ledger, setLedger] = useState(null);
  const [supplierId, setSupplierID] = useState("");
  const [selectPurId, setSelectPurId] = useState("");
  const [description, setDescription] = useState("Cash Received");
  const [bankId, setBankID] = useState("");
  const [chequeNo, setChequeNo] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [debitAmount, setDebitAmount] = useState("");
  const [rmks, setRemarks] = useState("");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const [addMrTransaction] = useAddMrTransactionMutation();

  const [loading, setLoading] = useState(false);
  const handleCreate = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("jv_no", genPy);
    formData.append("jv_type", 4);
    formData.append("trDate", trDate);
    formData.append("ledger_id", 2);
    formData.append("tag_ac_id", supplierId);
    formData.append("invoice_id", selectPurId);
    formData.append("description", rmks);
    formData.append("dabit_amount", debitAmount);
    formData.append("p_method", description);
    formData.append("bank_id", bankId);
    formData.append("chq_no", chequeNo);
    formData.append("chq_date", chequeDate);
    if (image) formData.append("chq_img", image);
    formData.append("created_by", user?.id);

    if (!supplierId || !debitAmount) {
      toast.error("Dealer, Amount, Or Payment is required");
      setLoading(false);
    } else {
      try {
        const response = await addMrTransaction(formData);
        if (response.data) {
          setLoading(false);
          setSupplierID("");
          setDescription("Cash Received");
          setDebitAmount("");
          setBankID("");
          setChequeDate("");
          setChequeNo("");
          setRemarks("");
          setImage(null);
          setPreview(null);
          toast.success("Added Success...!!!");
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error);
      }
    }
  };
  const particulars = ["Cash Received", "Cheque Receive"];

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl">Supplier Payment</h1>
      </div>
      <div>
        <form className="bg-white shadow-md p-2 grid grid-cols-1 lg:grid-cols-5 gap-4">
          <div className="flex flex-col gap-1">
            <label>Select Supplier</label>
            <select
              value={supplierId}
              onChange={(e) => setSupplierID(Number(e.target.value))}
              className="border h-8 pl-1"
            >
              <option>--select--</option>
              {suppliers?.map((supplier) => (
                <option key={supplier?.id} value={supplier?.id}>
                  {supplier?.s_name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label>Select Purchase</label>
            <select
              value={selectPurId}
              onChange={(e) => setSelectPurId(e.target.value)}
              className="border h-8 pl-1"
            >
              <option value="">--select--</option>
              {purchases?.map((pur) => (
                <option key={pur?.id} value={pur?.id}>
                  {pur?.pu_no}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label>Payment-No</label>
            <input
              type="text"
              value={genPy}
              className="border h-8 pl-1 focus:outline-none"
              disabled
            />
          </div>
          <div className="flex flex-col gap-1">
            <label>PY-Date</label>
            <input
              type="date"
              value={trDate}
              onChange={(e) => setTrDate(e.target.value)}
              className="border h-8 pl-1 bg-slate-50"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label>Payment Amount</label>
            <input
              type="text"
              value={debitAmount}
              onChange={(e) => setDebitAmount(Number(e.target.value))}
              className="border h-8 pl-1 focus:outline-none"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label>Payment Method</label>
            <select
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="border h-8 pl-1"
            >
              {/* <option>--select--</option> */}
              {particulars?.map((desc, index) => (
                <option key={index} value={desc}>
                  {desc}
                </option>
              ))}
            </select>
          </div>
          {description == "Cheque Receive" ? (
            <div className="flex flex-col gap-1">
              <label>Bank Name</label>
              <select
                value={bankId}
                onChange={(e) => setBankID(e.target.value)}
                className="border h-8 pl-1"
              >
                <option value="">--select--</option>
                {bankList?.map((bank, index) => (
                  <option key={bank?.id} value={bank?.id}>
                    {bank?.name}
                  </option>
                ))}
              </select>
            </div>
          ) : null}
          {description == "Cheque Receive" ? (
            <div className="flex flex-col gap-1">
              <label>Cheque No</label>
              <input
                type="text"
                value={chequeNo}
                onChange={(e) => setChequeNo(e.target.value)}
                className="border h-8 pl-1 "
              />
            </div>
          ) : null}
          {description == "Cheque Receive" ? (
            <div className="flex flex-col gap-1">
              <label>Cheque-Date</label>
              <input
                type="date"
                value={chequeDate}
                onChange={(e) => setChequeDate(e.target.value)}
                className="border h-8 pl-1 "
              />
            </div>
          ) : null}
          {description == "Cheque Receive" ? (
            <div className="flex flex-col gap-1">
              <label>Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="border h-8 pl-1"
              />
              {preview && (
                <img
                  src={preview}
                  alt="Preview"
                  style={{ maxWidth: "100%", maxHeight: "200px" }}
                />
              )}
            </div>
          ) : null}
          <div className="flex flex-col gap-1">
            <label>Remarks</label>
            <textarea
              value={rmks}
              onChange={(e) => setRemarks(e.target.value)}
              className="border h- pl-1 focus:outline-none"
            />
          </div>
        </form>
        <div className="flex items-center gap-x-4 mt-8">
          <button
            onClick={handleCreate}
            className={`bg-green-500 text-white font-bold px-4 py-1 rounded-sm `}
          >
            {loading ? "Loading..." : "Submit"}
          </button>
          {/* {isActive === true && (
            <button
              onClick={() => setIsActive(false)}
              className="bg-blue-500 text-white font-bold px-4 py-1 mt-8 rounded"
            >
              New Entry
            </button>
          )} */}
          <button className="bg-cyan-700 text-white p-1 px-2 rounded-sm">
            <Link to="/dashboard/supplier/receipt" state={passState}>
              print
            </Link>
          </button>
          <div className="">
            <label className="font-bold">Previous Receipt:</label>
            <input
              type="number"
              onChange={(e) => setPrevMrNo(e.target.value)}
              className="border w-16 ml-2"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashPayment;
